import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateResumeSummaryMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeInput;
}>;


export type UpdateResumeSummaryMutation = { __typename?: 'Mutation', updateJobSeekerProfileResume?: { __typename?: 'UpdateJobSeekerProfileResumePayload', resume?: { __typename?: 'JobSeekerProfileResume', id: string, summary?: string | null } | null } | null };

export type AddResumeSkillsMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeSkillsInput;
}>;


export type AddResumeSkillsMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeSkills?: { __typename?: 'AddJobSeekerProfileResumeSkillsPayload', skills: Array<{ __typename?: 'JobSeekerProfileSkill', id: string, text?: string | null }> } | null };

export type DeleteResumeSkillsMutationVariables = Types.Exact<{
  input: Types.DeleteJobSeekerProfileResumeSkillsInput;
}>;


export type DeleteResumeSkillsMutation = { __typename?: 'Mutation', deleteJobSeekerProfileResumeSkills?: { __typename?: 'DeleteJobSeekerProfileResumeSkillsPayload', skillIds: Array<string> } | null };

export type AddResumeWorkExperiencesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeWorkExperiencesInput;
}>;


export type AddResumeWorkExperiencesMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeWorkExperiences?: { __typename?: 'AddJobSeekerProfileResumeWorkExperiencesPayload', workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, description?: string | null }> } | null };

export type UpdateResumeWorkExperiencesMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeWorkExperiencesInput;
}>;


export type UpdateResumeWorkExperiencesMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeWorkExperiences?: { __typename?: 'UpdateJobSeekerProfileResumeWorkExperiencesPayload', workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, description?: string | null }> } | null };

export type DeleteResumeWorkExperiencesMutationVariables = Types.Exact<{
  input: Types.DeleteJobSeekerProfileResumeWorkExperiencesInput;
}>;


export type DeleteResumeWorkExperiencesMutation = { __typename?: 'Mutation', deleteJobSeekerProfileResumeWorkExperiences?: { __typename?: 'DeleteJobSeekerProfileResumeWorkExperiencesPayload', workExperienceIds: Array<string> } | null };

export type AddResumeCertificationsMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeCertificationsInput;
}>;


export type AddResumeCertificationsMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeCertifications?: { __typename?: 'AddJobSeekerProfileResumeCertificationsPayload', certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null }> } | null };

export type UpdateResumeCertificationsMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeCertificationsInput;
}>;


export type UpdateResumeCertificationsMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeCertifications?: { __typename?: 'UpdateJobSeekerProfileResumeCertificationsPayload', certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null }> } | null };

export type AddResumeLicensesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeLicensesInput;
}>;


export type AddResumeLicensesMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeLicenses?: { __typename?: 'AddJobSeekerProfileResumeLicensesPayload', licenses: Array<{ __typename?: 'JobSeekerProfileLicense', id: string, title?: string | null }> } | null };

export type UpdateResumeLicensesMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeLicensesInput;
}>;


export type UpdateResumeLicensesMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeLicenses?: { __typename?: 'UpdateJobSeekerProfileResumeLicensesPayload', licenses: Array<{ __typename?: 'JobSeekerProfileLicense', id: string, title?: string | null }> } | null };

export type AddResumeLanguagesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeLanguagesInput;
}>;


export type AddResumeLanguagesMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeLanguages?: { __typename?: 'AddJobSeekerProfileResumeLanguagesPayload', languages: Array<{ __typename?: 'JobSeekerProfileLanguage', id: string }> } | null };

export type UpdateResumeLanguagesMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeLanguagesInput;
}>;


export type UpdateResumeLanguagesMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeLanguages?: { __typename?: 'UpdateJobSeekerProfileResumeLanguagesPayload', languages: Array<{ __typename?: 'JobSeekerProfileLanguage', id: string }> } | null };


export const UpdateResumeSummaryDocument = gql`
    mutation UpdateResumeSummary($input: UpdateJobSeekerProfileResumeInput!) {
  updateJobSeekerProfileResume(input: $input) {
    resume {
      id
      summary
    }
  }
}
    `;
export type UpdateResumeSummaryMutationFn = Apollo.MutationFunction<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>;

/**
 * __useUpdateResumeSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateResumeSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeSummaryMutation, { data, loading, error }] = useUpdateResumeSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>(UpdateResumeSummaryDocument, options);
      }
export type UpdateResumeSummaryMutationHookResult = ReturnType<typeof useUpdateResumeSummaryMutation>;
export type UpdateResumeSummaryMutationResult = Apollo.MutationResult<UpdateResumeSummaryMutation>;
export type UpdateResumeSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>;
export const AddResumeSkillsDocument = gql`
    mutation AddResumeSkills($input: AddJobSeekerProfileResumeSkillsInput!) {
  addJobSeekerProfileResumeSkills(input: $input) {
    skills {
      id
      text
    }
  }
}
    `;
export type AddResumeSkillsMutationFn = Apollo.MutationFunction<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>;

/**
 * __useAddResumeSkillsMutation__
 *
 * To run a mutation, you first call `useAddResumeSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeSkillsMutation, { data, loading, error }] = useAddResumeSkillsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeSkillsMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>(AddResumeSkillsDocument, options);
      }
export type AddResumeSkillsMutationHookResult = ReturnType<typeof useAddResumeSkillsMutation>;
export type AddResumeSkillsMutationResult = Apollo.MutationResult<AddResumeSkillsMutation>;
export type AddResumeSkillsMutationOptions = Apollo.BaseMutationOptions<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>;
export const DeleteResumeSkillsDocument = gql`
    mutation DeleteResumeSkills($input: DeleteJobSeekerProfileResumeSkillsInput!) {
  deleteJobSeekerProfileResumeSkills(input: $input) {
    skillIds
  }
}
    `;
export type DeleteResumeSkillsMutationFn = Apollo.MutationFunction<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>;

/**
 * __useDeleteResumeSkillsMutation__
 *
 * To run a mutation, you first call `useDeleteResumeSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeSkillsMutation, { data, loading, error }] = useDeleteResumeSkillsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteResumeSkillsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>(DeleteResumeSkillsDocument, options);
      }
export type DeleteResumeSkillsMutationHookResult = ReturnType<typeof useDeleteResumeSkillsMutation>;
export type DeleteResumeSkillsMutationResult = Apollo.MutationResult<DeleteResumeSkillsMutation>;
export type DeleteResumeSkillsMutationOptions = Apollo.BaseMutationOptions<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>;
export const AddResumeWorkExperiencesDocument = gql`
    mutation AddResumeWorkExperiences($input: AddJobSeekerProfileResumeWorkExperiencesInput!) {
  addJobSeekerProfileResumeWorkExperiences(input: $input) {
    workExperiences {
      id
      description
    }
  }
}
    `;
export type AddResumeWorkExperiencesMutationFn = Apollo.MutationFunction<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>;

/**
 * __useAddResumeWorkExperiencesMutation__
 *
 * To run a mutation, you first call `useAddResumeWorkExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeWorkExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeWorkExperiencesMutation, { data, loading, error }] = useAddResumeWorkExperiencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeWorkExperiencesMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>(AddResumeWorkExperiencesDocument, options);
      }
export type AddResumeWorkExperiencesMutationHookResult = ReturnType<typeof useAddResumeWorkExperiencesMutation>;
export type AddResumeWorkExperiencesMutationResult = Apollo.MutationResult<AddResumeWorkExperiencesMutation>;
export type AddResumeWorkExperiencesMutationOptions = Apollo.BaseMutationOptions<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>;
export const UpdateResumeWorkExperiencesDocument = gql`
    mutation UpdateResumeWorkExperiences($input: UpdateJobSeekerProfileResumeWorkExperiencesInput!) {
  updateJobSeekerProfileResumeWorkExperiences(input: $input) {
    workExperiences {
      id
      description
    }
  }
}
    `;
export type UpdateResumeWorkExperiencesMutationFn = Apollo.MutationFunction<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>;

/**
 * __useUpdateResumeWorkExperiencesMutation__
 *
 * To run a mutation, you first call `useUpdateResumeWorkExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeWorkExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeWorkExperiencesMutation, { data, loading, error }] = useUpdateResumeWorkExperiencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeWorkExperiencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>(UpdateResumeWorkExperiencesDocument, options);
      }
export type UpdateResumeWorkExperiencesMutationHookResult = ReturnType<typeof useUpdateResumeWorkExperiencesMutation>;
export type UpdateResumeWorkExperiencesMutationResult = Apollo.MutationResult<UpdateResumeWorkExperiencesMutation>;
export type UpdateResumeWorkExperiencesMutationOptions = Apollo.BaseMutationOptions<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>;
export const DeleteResumeWorkExperiencesDocument = gql`
    mutation DeleteResumeWorkExperiences($input: DeleteJobSeekerProfileResumeWorkExperiencesInput!) {
  deleteJobSeekerProfileResumeWorkExperiences(input: $input) {
    workExperienceIds
  }
}
    `;
export type DeleteResumeWorkExperiencesMutationFn = Apollo.MutationFunction<DeleteResumeWorkExperiencesMutation, DeleteResumeWorkExperiencesMutationVariables>;

/**
 * __useDeleteResumeWorkExperiencesMutation__
 *
 * To run a mutation, you first call `useDeleteResumeWorkExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeWorkExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeWorkExperiencesMutation, { data, loading, error }] = useDeleteResumeWorkExperiencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteResumeWorkExperiencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResumeWorkExperiencesMutation, DeleteResumeWorkExperiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResumeWorkExperiencesMutation, DeleteResumeWorkExperiencesMutationVariables>(DeleteResumeWorkExperiencesDocument, options);
      }
export type DeleteResumeWorkExperiencesMutationHookResult = ReturnType<typeof useDeleteResumeWorkExperiencesMutation>;
export type DeleteResumeWorkExperiencesMutationResult = Apollo.MutationResult<DeleteResumeWorkExperiencesMutation>;
export type DeleteResumeWorkExperiencesMutationOptions = Apollo.BaseMutationOptions<DeleteResumeWorkExperiencesMutation, DeleteResumeWorkExperiencesMutationVariables>;
export const AddResumeCertificationsDocument = gql`
    mutation AddResumeCertifications($input: AddJobSeekerProfileResumeCertificationsInput!) {
  addJobSeekerProfileResumeCertifications(input: $input) {
    certifications {
      id
      title
    }
  }
}
    `;
export type AddResumeCertificationsMutationFn = Apollo.MutationFunction<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>;

/**
 * __useAddResumeCertificationsMutation__
 *
 * To run a mutation, you first call `useAddResumeCertificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeCertificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeCertificationsMutation, { data, loading, error }] = useAddResumeCertificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeCertificationsMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>(AddResumeCertificationsDocument, options);
      }
export type AddResumeCertificationsMutationHookResult = ReturnType<typeof useAddResumeCertificationsMutation>;
export type AddResumeCertificationsMutationResult = Apollo.MutationResult<AddResumeCertificationsMutation>;
export type AddResumeCertificationsMutationOptions = Apollo.BaseMutationOptions<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>;
export const UpdateResumeCertificationsDocument = gql`
    mutation UpdateResumeCertifications($input: UpdateJobSeekerProfileResumeCertificationsInput!) {
  updateJobSeekerProfileResumeCertifications(input: $input) {
    certifications {
      id
      title
    }
  }
}
    `;
export type UpdateResumeCertificationsMutationFn = Apollo.MutationFunction<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>;

/**
 * __useUpdateResumeCertificationsMutation__
 *
 * To run a mutation, you first call `useUpdateResumeCertificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeCertificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeCertificationsMutation, { data, loading, error }] = useUpdateResumeCertificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeCertificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>(UpdateResumeCertificationsDocument, options);
      }
export type UpdateResumeCertificationsMutationHookResult = ReturnType<typeof useUpdateResumeCertificationsMutation>;
export type UpdateResumeCertificationsMutationResult = Apollo.MutationResult<UpdateResumeCertificationsMutation>;
export type UpdateResumeCertificationsMutationOptions = Apollo.BaseMutationOptions<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>;
export const AddResumeLicensesDocument = gql`
    mutation AddResumeLicenses($input: AddJobSeekerProfileResumeLicensesInput!) {
  addJobSeekerProfileResumeLicenses(input: $input) {
    licenses {
      id
      title
    }
  }
}
    `;
export type AddResumeLicensesMutationFn = Apollo.MutationFunction<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>;

/**
 * __useAddResumeLicensesMutation__
 *
 * To run a mutation, you first call `useAddResumeLicensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeLicensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeLicensesMutation, { data, loading, error }] = useAddResumeLicensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeLicensesMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>(AddResumeLicensesDocument, options);
      }
export type AddResumeLicensesMutationHookResult = ReturnType<typeof useAddResumeLicensesMutation>;
export type AddResumeLicensesMutationResult = Apollo.MutationResult<AddResumeLicensesMutation>;
export type AddResumeLicensesMutationOptions = Apollo.BaseMutationOptions<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>;
export const UpdateResumeLicensesDocument = gql`
    mutation UpdateResumeLicenses($input: UpdateJobSeekerProfileResumeLicensesInput!) {
  updateJobSeekerProfileResumeLicenses(input: $input) {
    licenses {
      id
      title
    }
  }
}
    `;
export type UpdateResumeLicensesMutationFn = Apollo.MutationFunction<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>;

/**
 * __useUpdateResumeLicensesMutation__
 *
 * To run a mutation, you first call `useUpdateResumeLicensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeLicensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeLicensesMutation, { data, loading, error }] = useUpdateResumeLicensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeLicensesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>(UpdateResumeLicensesDocument, options);
      }
export type UpdateResumeLicensesMutationHookResult = ReturnType<typeof useUpdateResumeLicensesMutation>;
export type UpdateResumeLicensesMutationResult = Apollo.MutationResult<UpdateResumeLicensesMutation>;
export type UpdateResumeLicensesMutationOptions = Apollo.BaseMutationOptions<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>;
export const AddResumeLanguagesDocument = gql`
    mutation AddResumeLanguages($input: AddJobSeekerProfileResumeLanguagesInput!) {
  addJobSeekerProfileResumeLanguages(input: $input) {
    languages {
      id
    }
  }
}
    `;
export type AddResumeLanguagesMutationFn = Apollo.MutationFunction<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>;

/**
 * __useAddResumeLanguagesMutation__
 *
 * To run a mutation, you first call `useAddResumeLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeLanguagesMutation, { data, loading, error }] = useAddResumeLanguagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeLanguagesMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>(AddResumeLanguagesDocument, options);
      }
export type AddResumeLanguagesMutationHookResult = ReturnType<typeof useAddResumeLanguagesMutation>;
export type AddResumeLanguagesMutationResult = Apollo.MutationResult<AddResumeLanguagesMutation>;
export type AddResumeLanguagesMutationOptions = Apollo.BaseMutationOptions<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>;
export const UpdateResumeLanguagesDocument = gql`
    mutation UpdateResumeLanguages($input: UpdateJobSeekerProfileResumeLanguagesInput!) {
  updateJobSeekerProfileResumeLanguages(input: $input) {
    languages {
      id
    }
  }
}
    `;
export type UpdateResumeLanguagesMutationFn = Apollo.MutationFunction<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>;

/**
 * __useUpdateResumeLanguagesMutation__
 *
 * To run a mutation, you first call `useUpdateResumeLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeLanguagesMutation, { data, loading, error }] = useUpdateResumeLanguagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeLanguagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>(UpdateResumeLanguagesDocument, options);
      }
export type UpdateResumeLanguagesMutationHookResult = ReturnType<typeof useUpdateResumeLanguagesMutation>;
export type UpdateResumeLanguagesMutationResult = Apollo.MutationResult<UpdateResumeLanguagesMutation>;
export type UpdateResumeLanguagesMutationOptions = Apollo.BaseMutationOptions<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>;